﻿import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import CustomBadge from "@/components/desktop/badge/CustomBadge";

import classes from "../maintainers.module.scss";

import { ReactComponent as PencilSvg } from "@/assets/images/desktop/editar.svg";
import { ReactComponent as RemoveSvg } from "@/assets/images/desktop/remove.svg";
import { formatMilesDecimalNew, hasPermission } from "@/services/Utils";

const EstatesParentsTableBody = ({ estates_parents, handleDelete, permissions, estates, regions }) => {
	const navigate = useNavigate();
	const { customer } = useSelector((state) => state.auth.user);

	const getRegionName = (regionId) => {
		if (!regionId || !regions) return "";
		const region = regions.find((r) => r.value === regionId);
		return region ? region.label : "";
	};

	const getLocalityName = (regionId, localityId) => {
		if (!regionId || !localityId || !regions) return "";
		const region = regions.find((r) => r.value === regionId);
		if (!region || !region.localities) return "";
		const locality = region.localities.find((l) => l.value === localityId);
		return locality ? locality.label : "";
	};

	return (
		<tbody>
			{estates_parents &&
				estates_parents.map((item, i) => {
					const estatesItem = estates && estates.filter((e) => item.estates.includes(e.value));

					return (
						<tr className={`${classes.table_tr}`} key={i}>
							<td className={`${classes.table_td} ${classes.first_td}`}>
								<div className={`${classes.table_div}  ${classes.first_div}`}>{i + 1}</div>
							</td>

							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{item.name}</div>
							</td>

							{customer && customer.use_estates_parents && (
								<td className={`${classes.table_td}`}>
									<div className={`${classes.table_div} `}>
										{estatesItem.map((estate, i) => {
											return (
												<CustomBadge key={i} variant="neutral" style={{ marginLeft: "5px" }}>
													{estate.label}
												</CustomBadge>
											);
										})}
									</div>
								</td>
							)}

							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{getRegionName(item.region)}</div>
							</td>
							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} `}>{getLocalityName(item.region, item.locality)}</div>
							</td>

							{!!customer.use_estates_parents && (
								<>
									<td className={`${classes.table_td}`}>
										<div className={`${classes.table_div}`} style={{ justifyContent: "center" }}>
											{item.hectares ? `${formatMilesDecimalNew(item.hectares)} ha` : ""}
										</div>
									</td>
									<td className={`${classes.table_td}`}>
										<div className={`${classes.table_div}`} style={{ justifyContent: "center" }}>
											{item.time_open}
										</div>
									</td>
									<td className={`${classes.table_td}`}>
										<div className={`${classes.table_div}`} style={{ justifyContent: "center" }}>
											{item.time_close}
										</div>
									</td>
								</>
							)}

							<td className={`${classes.table_td}`}>
								<div className={`${classes.table_div} ${classes.last_div}`}>
									{hasPermission("edit", permissions) && (
										<PencilSvg className={classes.icon} onClick={() => navigate("/configuracion/grupos_campos/editar/" + item.slug)} />
									)}
									{hasPermission("delete", permissions) && <RemoveSvg className={classes.icon} onClick={() => handleDelete(item)} />}
								</div>
							</td>
						</tr>
					);
				})}
		</tbody>
	);
};

export default EstatesParentsTableBody;
